import { takeEvery, all, select, put, call } from 'redux-saga/effects';
import { GET } from 'utils/request';
import { GET_MY, REQUEST_DATA_RESULT } from '../../containers/App/constants';
import {
  FETCH_MMT,
  FILTER_DEFAULT_LIMIT,
  MMT,
  REQUEST_VEHICLES,
  REQUEST_VEHICLE_FILTER,
  REQUEST_VEHICLE_FILTER_RESET,
  APPLY_VEHICLE_FILTERS,
} from './constants';
import { selectVehicleFilter } from './selectors';

function* requestVehicleFilter() {
  let filter = yield select(selectVehicleFilter());
  console.log('Filters to send: ', filter);
  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let text = filter.searchString?.trim() || null;
  const sortType = filter?.sortType;
  const order = filter?.order;

  let path = `vehicles/getList`;

  let searchParams = {
    offset,
    limit,
    text: text ?? undefined,
    filters: filter.properties?.map(f => (f.value?.id ? { ...f, value: [f.value.id + ''] } : f)),
  };

  if (!!sortType) {
    searchParams.sortType = sortType;
    searchParams.order = order ?? 'desc';
  }

  // No need of this anymore. Api has been modified to show rows where financial_price_b2b_incl_vat_btpm to the end of the list
  // if (sortType === 'financial_price_b2b_incl_vat_btpm') {
  //   searchParams.filters = [{
  //     key: 'financial_price_b2b_incl_vat_btpm',
  //     type: 'ranged',
  //     value: [1, Number.MAX_SAFE_INTEGER]
  //   }];
  // }

  yield put({
    type: GET_MY,
    id: REQUEST_VEHICLES,
    work: REQUEST_VEHICLES,
    gate: REQUEST_VEHICLES,
    path,
    post: searchParams,
  });
}

function* fetchMMT() {
  let result = (yield call(GET, '/public/mmt.json')).data;
  yield put({
    type: REQUEST_DATA_RESULT,
    id: MMT,
    result,
  });
}

export function* vehiclesSaga() {
  yield all([
    takeEvery(APPLY_VEHICLE_FILTERS, requestVehicleFilter),
    takeEvery(REQUEST_VEHICLE_FILTER, requestVehicleFilter),
    takeEvery(REQUEST_VEHICLE_FILTER_RESET, requestVehicleFilter),
    takeEvery(FETCH_MMT, fetchMMT),
    //takeEvery(INITIATE_VEHICLE_EDIT, initiateVehicleEdit),
  ]);
}
